const complementaryProducts = document.querySelector('product-recommendations');

if (complementaryProducts) {
  setTimeout(() => {
    const quantityButtons = complementaryProducts.querySelectorAll('.quantity-selector__button');

    quantityButtons.forEach((button) => {
      button.addEventListener('click', (event) => {
        let parentForm = event.currentTarget.closest('form');

        if (parentForm) {
          let submitButton = parentForm.querySelector('button[type="submit"] span.cart-price');
          let buttonPrice = parseInt(submitButton.dataset.price);
          let inputValue = parseInt(parentForm.querySelector('.quantity-selector__input').value);
          const newPrice = new Intl.NumberFormat('en-GB').format(inputValue * buttonPrice);
          if (newPrice) {
            submitButton.innerHTML = ` \£${newPrice}.00`;
          }
        }
      });
    });
  }, 1000);
}
